<div
  class="car-hire-card"
  [ngClass]="policyClass"
  role="button"
  [attr.tabindex]="isBlocked ? -1 : 0"
  [attr.aria-disabled]="isBlocked ? true : null"
  i18n-aria-label="@@chatCarHireSelect"
  aria-label="Select {{ card.vehicleDescription }}"
  (click)="select()"
  (keydown.enter)="select()"
  (keydown.space)="select()"
>
  @if (policyLabel) {
    <span class="visuallyhidden">{{ policyLabel }}</span>
  }
  <div class="car-hire-card__body">
    <div class="car-hire-card__info">
      <!-- Vendor -->
      <div class="car-hire-card__vendor">
        @if (card.vendorLogoUrl && !logoLoadError) {
          <img
            [src]="card.vendorLogoUrl"
            [alt]="card.vendorName"
            class="car-hire-card__vendor-logo"
            [ngClass]="vendorLogoClass"
            (error)="logoLoadError = true"
          />
        } @else {
          <span class="car-hire-card__vendor-name">{{ card.vendorName }}</span>
        }
      </div>

      <!-- Vehicle description -->
      <div class="car-hire-card__vehicle">
        @if (card.vehicleDescription) {
          {{ card.vehicleDescription }}
        } @else {
          <span i18n="@@chatCarHireVehicle">Vehicle</span>
        }
      </div>

      <!-- Vehicle badges -->
      <div class="car-hire-card__badges">
        @if (card.carClass) {
          <span class="car-hire-card__badge">{{ card.carClass }}</span>
        }
        @if (card.transmission === 'Auto') {
          <span class="car-hire-card__badge" i18n="@@chatCarHireAutomatic">Automatic</span>
        } @else if (card.transmission) {
          <span class="car-hire-card__badge" i18n="@@chatCarHireManual">Manual</span>
        }
        @if (card.airCon) {
          <span class="car-hire-card__badge car-hire-card__badge--aircon" i18n="@@chatCarHireAirCon"
            >A/C</span
          >
        }
        @if (card.doorsCount) {
          <span class="car-hire-card__badge"
            >{{ card.doorsCount }}
            <ng-container i18n="@@chatCarHireDoors">doors</ng-container></span
          >
        }
      </div>

      <!-- Pickup/dropoff locations -->
      <div class="car-hire-card__row">
        <fa-icon [icon]="faLocationDot"></fa-icon>
        <span>{{ card.pickupLocation }}</span>
      </div>
      @if (card.dropoffLocation !== card.pickupLocation) {
        <div class="car-hire-card__row car-hire-card__row--dropoff">
          <fa-icon [icon]="faLocationDot"></fa-icon>
          <span
            ><ng-container i18n="@@chatCarHireReturnTo">Return to</ng-container>:
            {{ card.dropoffLocation }}</span
          >
        </div>
      }

      <!-- Policy indicator: same component/tooltip as the results page. -->
      <app-warning-tags
        [ticket]="headlineWarningTicket"
        [displayCheck]="false"
        (click)="$event.stopPropagation()"
      ></app-warning-tags>
    </div>

    <div class="car-hire-card__price-col">
      <div class="car-hire-card__price-group">
        <span class="car-hire-card__price-label" i18n="@@chatCarHireFrom">From</span>
        @if (card.price) {
          <span class="car-hire-card__price-amount">{{ formattedPrice }}</span>
        }
        @if (formattedPricePerDay) {
          <span class="car-hire-card__price-per-day">{{ formattedPricePerDay }}</span>
        }
      </div>
    </div>
  </div>
</div>
